<template>
    <div>
        <div class="row">
            <div class="col-md-12 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-clock-o"></i>
                            Récapitulatif
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h4 v-if="meetingRequestInfosProp.expertisePartnerRadio === 'carizy'">
                                La demande de rendez-vous d'inspection a bien été prise en compte sur les créneaux suivants:
                            </h4>
                            <h4 v-if="meetingRequestInfosProp.expertisePartnerRadio === 'carizy'" class="pl20">
                                - le {{ meetingRequestInfosProp.firstTimeSlot.date }} à {{ formatTime(meetingRequestInfosProp.firstTimeSlot.timeFrom) }}<br>
                                - le {{ meetingRequestInfosProp.secondTimeSlot.date }} à {{ formatTime(meetingRequestInfosProp.secondTimeSlot.timeFrom) }}<br><br>
                                Adresse: {{ formattedAddress }}
                            </h4>
                            <h4 v-if="meetingRequestInfosProp.expertisePartnerRadio === 'feuvert'">
                                Le rendez-vous d'inspection est confirmé pour le {{ meetingRequestInfosProp.firstTimeSlot.date }} à {{ meetingRequestInfosProp.firstTimeSlot.timeFrom }}<br><br>
                                Adresse: {{ feuvertFormattedAddress }}
                            </h4>
                        </div>
                    </div>
                    <div class="row">
                        <div id="ibox-content">
                            <div id="vertical-timeline" class="vertical-container light-timeline'">
                                <div v-if="meetingRequestInfosProp.expertisePartnerRadio === 'carizy'" class="vertical-timeline-block">
                                    <div class="vertical-timeline-icon navy-bg">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                    <div class="vertical-timeline-content">
                                        <h2>Ce qu'il nous reste à faire</h2>
                                        <p>
                                            Nous allons transmettre votre demande d'inspection aux inspecteurs disponible sur votre zone.
                                        </p>
                                        <p>
                                            Dès lors que votre demande sera confirmée, vous receverez un mail ainsi qu'un sms vous donnant l'horaire exacte du rendez-vous.
                                        </p>
                                    </div>
                                </div>
                                <div class="vertical-timeline-block">
                                    <div class="vertical-timeline-icon blue-bg">
                                        <i class="fa fa-file-text"></i>
                                    </div>
                                    <div class="vertical-timeline-content">
                                        <h2>Ce qu'il vous reste à faire</h2>
                                        <p v-if="entity === 'carizy'">
                                            Envoyez nous les documents ci-dessous à documents@carizy.com
                                        </p>
                                        <p v-if="entity === 'renault'">
                                            Envoyez nous les documents ci-dessous à documents@sellyourcar.renault.fr 
                                        </p>
                                        <ul class="paddingLeft20px">
                                            <li>- Carte grise</li>
                                            <li v-if="vehicleDateIsInMoreThan4YearsOld">- Contrôle technique de moins de 6 mois</li>
                                            <li>- Carte d’identité recto/verso de {{ sellerInfosProp.seller.civility }} {{ sellerInfosProp.seller.firstName }} {{ sellerInfosProp.seller.lastName }}</li>
                                            <li v-if="sellerInfosProp.owner.firstName">- Carte d’identité recto/verso de {{ sellerInfosProp.owner.civility }} {{ sellerInfosProp.owner.firstName }} {{ sellerInfosProp.owner.lastName }}</li>
                                        </ul>
                                        <p>Ces documents nous permettront de préparer au mieux votre rendez-vous d’inspection et de gagner du temps le jour j !</p>
                                        <!-- Needed soon -->
                                        <!-- <a href="#" class="btn btn-sm btn-info"> Envoyer mail </a> -->
                                    </div>
                                </div>
                                <div class="vertical-timeline-block">
                                    <div class="vertical-timeline-icon yellow-bg">
                                        <i class="fa fa-exclamation-triangle"></i>
                                    </div>
                                    <div class="vertical-timeline-content">
                                        <h2>Ne pas oublier !</h2>
                                        <p>Pensez à nettoyer correctement l’intérieur et l’extérieur de votre véhicule pour permettre à notre inspecteur de réaliser les meilleurs photos possible !</p>
                                        <p>Enfin, n’oubliez pas d’apporter tous les documents nécessaires ainsi que le double des clés de votre véhicule le jour de l’inspection.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt20 centerText">
                        <button
                                @click="goToInspectionList"
                                type="button"
                                class="btn btn-lg"
                                :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
                        >
                            Retour à la liste des inspections
                        </button>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: "Recapitulatif",

        props: {
            activeStep: {
                type: Number,
                required: true
            },
            entity: {
                type: String,
                required: true
            },
            vehicle: {
                type: Object
            },
            quotation: {
                type: Object,
            },
            vehicleInfosProp: {
                type: Object
            },
            estimationInfosProp: {
                type: Object
            },
            sellerInfosProp: {
                type: Object
            },
            meetingRequestInfosProp: {
                type: Object
            },
        },

        data: () => ({

        }),

        mounted () {
            this.scrollToTop()
        },

        computed: {
            vehicleDateIsInMoreThan4YearsOld () {
                let date4YearsAgo = moment().subtract(4, 'years')
                return moment(date4YearsAgo).isAfter(this.vehicle.dateMEC)
            },
            formattedAddress () {
                return this.vehicleInfosProp.address.address + ", " + this.vehicleInfosProp.address.zipCode + ", " + this.vehicleInfosProp.address.city
            },
            feuvertFormattedAddress () {
                return this.vehicleInfosProp.availablePartners.feuvert.address + ", " + this.vehicleInfosProp.availablePartners.feuvert.zipcode + ", " + this.vehicleInfosProp.availablePartners.feuvert.city
            }
        },

        methods: {
            scrollToTop() {
                window.scrollTo(0,0);
            },
            goToInspectionList() {
                window.location.href = process.env.VUE_APP_BACKOFFICE_DOMAIN + process.env.VUE_APP_RDV_LIST_PRO
            },
            formatTime (time) {
                return time.replace(':', 'h')
            }
        }
    }
</script>

<style scoped>

</style>